module.exports = __webpack_public_path__ + "img/belajarid.f9e83321.png";